import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

function ListItem({ name, onClick, link }) {
  return (
    <li onClick={onClick}>
      {link ? (
        <a href={`/blog`} className="sidebar-list-link">
          {name} <FontAwesomeIcon icon={faChevronLeft} />
        </a>
      ) : (
        <div className="sidebar-list-link" style={{ cursor: "pointer" }}>
          {name} <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      )}
    </li>
  );
}

export default function SidebarList({ children }) {
  return <ul className="sidebar-card-list">{children}</ul>;
}

export { ListItem, SidebarList };
